import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/reset.css'
import './assets/js/rem.js'
import VConsole from 'vconsole';

new VConsole();
createApp(App).mount('#app')
